import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import { MENU_ITEM_NAMES } from 'styles/constants/appearanceSectionNames';
import Typography from '@mui/material/Typography';
import {
  getItemDescriptionsAndPricesTypography,
  getSectionNavMediumColor
} from 'styles/helpers/getThemeStyles';

const AddedToCart = styled(Typography)(({ theme }) => {
  return {
    marginBottom: '0.25rem',
    fontSize: '1rem',
    color: theme.palette.sectionNav.link.main
  };
});

const AddedItemText = styled('div')({
  fontSize: '0.875rem',
  marginTop: '0.25rem'
});

const SoySpan = styled('span')(({ theme }) => {
  return {
    color: getSectionNavMediumColor(theme),
    ...getItemDescriptionsAndPricesTypography(theme)
  };
});

const SuccessfullAddItemText = ({ cartItems, item }) => {
  const lastCartItemIndex = cartItems.length - 1;
  const lastAddedItemQuantity =
    cartItems.length >= 1 ? cartItems[lastCartItemIndex].quantity : null;
  const styles = { variant: MENU_ITEM_NAMES };
  return (
    <div>
      <AddedToCart {...styles}>Added to Cart</AddedToCart>
      <AddedItemText>
        <SoySpan>{lastAddedItemQuantity}x</SoySpan>
        <SoySpan> &nbsp;{item}</SoySpan>
      </AddedItemText>
    </div>
  );
};

SuccessfullAddItemText.propTypes = {
  cartItems: PropTypes.array.isRequired,
  item: PropTypes.string.isRequired
};

SuccessfullAddItemText.defaultProps = {
  cartItems: [],
  item: ''
};

export default SuccessfullAddItemText;
